import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

export default function AuthCallbackPage() {
  const [params]  = useSearchParams();
  const navigate  = useNavigate();
  const [status, setStatus] = useState('Logger inn…');

  useEffect(() => {
    const token = params.get('token');
    const error = params.get('error');

    if (error) {
      setStatus('Innlogging feilet. Sender deg tilbake…');
      setTimeout(() => navigate('/logg-inn'), 2500);
      return;
    }

    if (!token) {
      navigate('/logg-inn');
      return;
    }

    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    axios.get('/api/auth/me')
      .then(() => {
        setStatus('Innlogget! Videresender…');
        window.location.href = '/';
      })
      .catch(err => {
        console.error('[AuthCallback] Feil:', err);
        setStatus('Feil ved innlogging. Prøv igjen.');
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        setTimeout(() => navigate('/logg-inn'), 2500);
      });
  }, [params, navigate]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#0E0828',
      flexDirection: 'column', gap: 20, fontFamily: "'Plus Jakarta Sans',sans-serif",
    }}>
      <div style={{
        width: 52, height: 52,
        border: '4px solid rgba(255,255,255,0.15)',
        borderTop: '4px solid #7C6FF7',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <p style={{ fontSize: 16, fontWeight: 600, color: '#fff', margin: 0 }}>
        {status}
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
